module.exports = __webpack_public_path__ + "img/logo-instagram.b51977d0.svg";